import React from 'react';
import brand_logo from 'assets/images/app-brand.png';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function Brand({ className }) {
  return (
    <Link to="/">
      <img className={className} src={brand_logo} alt="scorebox" />
    </Link>
  );
}

Brand.defaultProps = {
  className: 'h-8 w-auto',
};

Brand.propTypes = {
  className: PropTypes.string,
};

export default Brand;
